import React, { useState, useEffect } from 'react';
import { Switch } from '@mantine/core';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { EditLeaveTypes, HEADERS } from '../../api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';



export default function EditTimeOffType() {
  const { leave_type_id, leave_type_name } = useParams();

  const [editedLeaveTypeName, setEditedLeaveTypeName] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();




  useEffect(() => {
    // $&
    // $&

    // Set the initial value of the editedLeaveTypeName when the component mounts
    setEditedLeaveTypeName(decodeURIComponent(leave_type_name || ''));
  }, [leave_type_name]);

  const handleCancel = () => {
    navigate('/leave-page/leave-type');
  };

  const handleUpdate = async () => {
    try {
      // Make the API request to update leave type
      const response = await axios.post(EditLeaveTypes,
        {
          leave_type_id: leave_type_id,
          leave_type_name: editedLeaveTypeName,
        }, { headers: HEADERS },

      );

      if (response.data.response_code === '0000') {
        // $&
        Swal.fire('Updated!', 'Leave type has been updated.', 'success');
      } else {
        console.error('Failed to update leave type:', response.data.response_description);
        Swal.fire('Failed!', 'Failed to update the leave type. Please try again later.', 'error');
      }
      navigate('/leave-page/leave-type');


    } catch (error) {
      console.error('Error updating leave type:', error);
    }
  };

  return (
    <div className="box">
      <div className="row">
        <div className="col-lg-6">
          <h5>Edit Leave Type</h5>
          <div className="card mt-3" id="cards">
            <div className="d-flex holiday">
              <div className="form-group p-3 col-md-9">
                <label>Leave Type</label>
                <input
                  type="text"
                  placeholder="Casual Leave"
                  required
                  value={editedLeaveTypeName}
                  onChange={(e) => setEditedLeaveTypeName(e.target.value)}
                />
              </div>
              <div className="form-group input-check mt-3">Disable
                <Switch checked={isDisabled} onChange={() => setIsDisabled(!isDisabled)} />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-2 cancel-update">
            <button className="button-outline" onClick={handleUpdate}>
              Update
            </button>
            <button type="button" className="button-outline" onClick={handleCancel}>
              Cancel
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}
